import { create } from 'zustand';
import client from '@/clients/customer/api-client';
import { CustomerProfile } from '@/lib/types/customer/Profile';
import { storage_keys } from '@/constant/configs';
import { removeCustomerAuthCreds } from '@/lib/utils/functions';
import { deleteFCMToken } from '@/lib/utils/fcm-cleanup';

type User = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  phone?: string | null;
  phone_verified?: boolean;
  avatar: string | null;
  referrer_id: number;
  referral_code: string;
};

type UserState = {
  user: User | null;
};

type UserActions = {
  setUser: (user: CustomerProfile) => void;
  getUpdatedUser: () => Promise<void>;
  getUser: (userAuthToken?: string) => void;
  removeUser: () => Promise<void>;
};

export const useUserStore = create<UserState & UserActions>((set, get) => ({
  user: null,

  setUser: (user: CustomerProfile) => {
    const userData: User = {
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      avatar: user.media?.avatar?.[0]?.thumb_url ?? '',
      phone: user.phone,
      phone_verified: user.phone_verified || false,
      referrer_id: user.referrer_id,
      referral_code: user.referral_code,
    };
    localStorage.setItem('4TA_CUSTOMER_PROFILE', JSON.stringify(userData));
    set({ user: userData });
  },

  getUser: (userAuthToken?: string) => {
    const token = localStorage.getItem(storage_keys.customer_token) ?? null;
    if (token && userAuthToken) {
      const userString = localStorage.getItem('4TA_CUSTOMER_PROFILE');

      if (userString) {
        const user = JSON.parse(userString) as User;
        set({ user });
      } else {
        get().removeUser();
      }
    } else {
      get().removeUser();
    }
  },

  getUpdatedUser: async () => {
    const res = await client.get('/profile');
    if (res.status === 200) {
      const data = res.data.data as CustomerProfile;
      // console.log(data.avatar?.thumb_url);
      const userData: User = {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        avatar: data.media?.avatar?.[0]?.thumb_url ?? '',
        phone: data.phone,
        phone_verified: data.phone_verified || false,
        referrer_id: data.referrer_id,
        referral_code: data.referral_code,
      };
      localStorage.setItem('4TA_CUSTOMER_PROFILE', JSON.stringify(userData));
      set({ user: userData });
    }
  },

  removeUser: async () => {
    await deleteFCMToken();
    await removeCustomerAuthCreds();
    set({ user: null });
  },
}));
